import { useEffect } from 'react'
import useSWR from 'swr'
import { JOBS_URL } from '../../constants/api'
import { useSetJobsState } from '../../store/jobsState'
import { useSetLoadingState } from '../../store/loadingState'
import fetcher from '../../utils/fetcher'
import { ResponseData } from './types'

export type JobsResponse = Array<{
  id: string
  title: string
  posts: string[]
  recruit_count: number
  requirement: string
  duty: string
  salary: string
  locations: Array<{ name: string }>
  delivered: boolean
  company: string
}>

export default function useFetchJobs() {
  const result = useSWR<ResponseData<JobsResponse>>(JOBS_URL, fetcher.get)
  const setJobsState = useSetJobsState()
  const setLoading = useSetLoadingState()
  
  
  useEffect(()=>{
    // loading
    if(!result.data) {
      setLoading(true)
    }
    // res
    if(result.data) { 
      setJobsState(result.data.data)
      setLoading(false)
    }
  }, [result.data, setJobsState, setLoading])

  return {
    ...result,
    data: result.data
  }
}
